import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {

  @Input() location;
  active = false;
  whitelist = ['location_inner', 'location_name', 'location_users'];

  numUsers;
  constructor(public shared: Shared) {
  }

  ngOnInit() {
      //console.log(location);
      this.shared.UsersObservable.subscribe(user_list => {
          this.numUsers = user_list.filter(user => {
              //console.log(user.location, this.location.$key);
              return user.location === this.location.$key;
          }).length;
      });
  }

  toggleActive(event){
      let t = event.target;
      if(t.localName === 'div' && (this.whitelist.includes(t.className))){
          this.active = !this.active;
      }
  }

  save(){
      const key = this.location.$key;
      delete this.location.$key;
      this.shared.locationsRef.update(key, this.location);
  }
}



// WEBPACK FOOTER //
// ./src/app/location/location.component.ts